import {removeLengthUnitFromCssVar} from "../utilities/helper-function";

class InfoBox {
    constructor(element) {
        this.infobox = element;
        this.isExpandable = this.infobox.classList.contains('info-box--expandable');
        this.infoboxBody = this.infobox.querySelector('.info-box__base');
        this.infoboxBodyHeight = 0;
        this.infoboxBodyTrimmedHeight = 0;
        this.limitedHeightActivated = false;

        this.buttons = this.infobox.querySelector('.info-box__buttons');
        this.moreBtn = this.infobox.querySelector('.info-box__button--more' +
            ' button');
        this.lessBtn = this.infobox.querySelector('.info-box__button--less' +
            ' button');

        this.rootStyles = getComputedStyle(document.documentElement);

        this.lineHeight = removeLengthUnitFromCssVar(this.rootStyles.getPropertyValue('--infobox-line-height').trim())
        this.lineHeightDesktop = removeLengthUnitFromCssVar(this.rootStyles.getPropertyValue('--infobox-line-height--desktop').trim())

        if(this.isExpandable) {
            window.addEventListener('load', () => {
                this.updateHeight();
                this.activateLimitedHeight();
            })

            window.addEventListener('resize', () => {
                this.updateHeight();
                this.activateLimitedHeight();
            })

            this.moreBtn.addEventListener('click', () => this.slideDown());
            this.lessBtn.addEventListener('click', () => this.slideUp());
        }
    }

    updateHeight() {
        this.infoboxBodyHeight =this.infoboxBody.scrollHeight;
        this.infoboxBodyTrimmedHeight = window.innerWidth < 1200 ? this.lineHeight * 5 : this.lineHeightDesktop * 5;
    }

    activateLimitedHeight() {
        if(this.infoboxBodyHeight > this.infoboxBodyTrimmedHeight) {
            this.limitedHeightActivated = true;
            if(this.buttons.classList.contains('info-box__buttons--display-none')) {
                this.buttons.classList.remove('info-box__buttons--display-none')
            }

            this.infoboxBody.classList.add('info-box__base--trimmed');
            this.slideUp();

        } else {
            this.limitedHeightActivated = false;
            this.buttons.classList.add('info-box__buttons--display-none');
            this.infoboxBody.classList.remove('info-box__base--trimmed');
            this.buttons.classList.add('info-box__buttons--display-none')
        }
    }

    slideUp() {
        if(!this.limitedHeightActivated) return;
        this.infoboxBody.style.removeProperty('height');
        this.infoboxBody.classList.add('info-box__base--trimmed');
    }

    slideDown() {
        if(!this.limitedHeightActivated) return;
        this.infoboxBody.classList.remove('info-box__base--trimmed');
        this.infoboxBody.style.height = this.infoboxBodyHeight + "px";
    }
}

export default InfoBox;